import * as React from 'react';
import { useEffect, useState } from 'react';

import { Flashbar, SpaceBetween } from '@amzn/awsui-components-react-v3/polaris';
import { TABLE_CONTENT_TYPE } from 'src/commons/constants';
import { DataQualityReportTable } from 'src/components/catalog/dataquality/dataQualityReportTable';
import { DataQualityTable } from 'src/components/catalog/dataquality/dataQualityTable';
import { DataQualityLineChart } from 'src/components/catalog/dataquality/dataQualityLineChart';
import { DATAFI_DQ_TYPE, DQ_RULE_PASS_STATUS, GLUE_DQ_TYPE } from 'src/components/catalog/dataquality/dqConstants';
import { DataQualityTrendsTable } from 'src/components/catalog/dataquality/dataQualityTrendsTable';
import { DataQualityList } from 'aws-sdk/clients/awsdlhybridcatalogservicelambda';

export interface DataQualityProps {
  setContentType: any;
  loadingDataQuality: boolean;
  setLoadingDataQuality: any;
  dataQualityMetrics: DataQualityList;
  setDataQualityMetrics: any;
  notifications: any;
}

export const DataQuality = (props: DataQualityProps) => {
  const [selectedDataQuality, setSelectedDataQuality] = useState(null);

  useEffect(() => {
    props.setContentType(TABLE_CONTENT_TYPE);
  }, []);

  const calculateDQScore = (dataQualityMetric) => {
    let passedRules = 0;
    let totalRules = 0;
    if (dataQualityMetric.Type === GLUE_DQ_TYPE) {
      for (let j = 0; j < dataQualityMetric.Data?.metrics?.length; j++) {
        totalRules++;
        if (dataQualityMetric.Data?.metrics[j]?.result === DQ_RULE_PASS_STATUS) {
          passedRules++;
        }
      }
    } else if (dataQualityMetric.Type === DATAFI_DQ_TYPE) {
      for (let j = 0; j < dataQualityMetric.Data?.rules?.length; j++) {
        totalRules++;
        if (dataQualityMetric.Data?.rules[j]?.result === DQ_RULE_PASS_STATUS) {
          passedRules++;
        }
      }
      for (let j = 0; j < dataQualityMetric.Data?.trends?.length; j++) {
        totalRules++;
        if (dataQualityMetric.Data?.trends[j]?.result === DQ_RULE_PASS_STATUS) {
          passedRules++;
        }
      }
    }
    return {
      score: (passedRules / totalRules) * 100,
      pass: passedRules,
      total: totalRules,
    };
  };

  return (
    <>
      <Flashbar items={props.notifications} />
      <SpaceBetween size={'l'}>
        <DataQualityLineChart
          dataQualityReports={props.dataQualityMetrics}
          loadingDataQuality={props.loadingDataQuality}
        />

        <DataQualityTable
          dataQualityReports={props.dataQualityMetrics}
          loadingDataQuality={props.loadingDataQuality}
          calculateDQScore={calculateDQScore}
          setSelectedItem={setSelectedDataQuality}
        />
        {selectedDataQuality !== null && selectedDataQuality.length > 0 && (
          <DataQualityReportTable dataQualityMetrics={selectedDataQuality[0]} />
        )}
        {selectedDataQuality !== null &&
          selectedDataQuality.length > 0 &&
          selectedDataQuality[0].Data?.trends?.length > 0 && (
            <DataQualityTrendsTable dataQualityMetrics={selectedDataQuality[0]} />
          )}
      </SpaceBetween>
    </>
  );
};
